module.exports = __webpack_public_path__ + "static/media/scubatocat.a6ea85ca.png";